const NAV_OFFSET = 84

export const scrollToId = (id) => {
  if (id === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }
  const element = document.getElementById(id)
  if (!element) return
  const top = element.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET
  window.scrollTo({ top, behavior: 'smooth' })
}

// Scrolls to a homepage section, routing back to "/" first when needed.
export const goToSection = (id, location, navigate) => {
  if (location.pathname !== '/') {
    navigate(id === 'home' ? '/' : `/#${id}`)
    return
  }
  scrollToId(id)
}

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
